module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/feed-o-7c53d5b0c9c7bffe586e0e10a5e08224.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/feed-o.svg
// module id = S9Iu
// module chunks = 24